export default "__VITE_ASSET__DKuPqMgv__"